<style scoped>
  .title{
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
</style>
<template>
  <div>
    <Modal
      v-model="config.modal"
      width="800"
      cancel-text=""
      ok-text="关闭"
    >
      <div slot="header">
        <span class="title text-large text-bold">{{ modal_title }}</span>
        <Button
          v-if="assets.length"
          size="small"
          @click="exportAssets"
        >
          导出Excel
        </Button>
      </div>
      <div
        v-show="page_info.total"
        class="line"
      >
        <Page
          show-total
          show-elevator
          :current="page_info.current"
          :total="page_info.total"
          :page-size="page_info.page_size"
          @on-change="pageChange"
        />
      </div>
      <Table
        size="small"
        :columns="asset_columns"
        :data="assets"
        border
        :loading="loading"
      />
    </Modal>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    data() {
      return {
        params: {
          per_page: 10,
          page: 1,
          customer_id: 0,
          search: '',
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 15
        },
        loading: false,
        customer: {},
        assets: [],
        asset_columns: [
          {
            title: '编号',
            key: 'uid',
            fixed: 'left',
            align: 'center',
            width: 95
          },
          {
            title: '名称',
            key: 'name',
            fixed: 'left',
            align: 'center',
            width: 120,
            render: (h, params) => {
              const asset_name = params.row.asset_name;
              return h('div', asset_name.name);
            }
          },
          {
            title: '型号',
            key: 'asset_model',
            align: 'center',
            width: 120,
            render: (h, params) => {
              return h('div', params.row.asset_version ? params.row.asset_version.name : (params.row.asset_model || "-"))
            }
          },
          {
            title: '当前使用人(领用时间)',
            align: 'center',
            width: 130,
            render: (h, params) => {
              const asset_customer = params.row.customer;
              if (asset_customer && asset_customer.id) {
                const latest_in_out_record = params.row.latest_in_out_record;
                const date = latest_in_out_record.execute_date ? this.$util.formatDate(latest_in_out_record.execute_date) : '';
                return (
                  <div
                  style="white-space: pre-line;"
                  >
                    { `${asset_customer.account} ${date} \n ${asset_customer.email}` }
                  </div>
                );
              }
              return h('div', '-');
            },
          },
          {
            title: 'SN',
            align: 'center',
            key: 'sn',
            width: 120
          },
          {
            title: '购买日期',
            align: 'center',
            key: 'purchase_date',
            width: 80
          },
          {
            title: '购入价格',
            align: 'center',
            render: (h, params) => {
              return h('div', '￥ ' + this.$util.formatPrice(params.row.price));
            },
            width: 100
          },
          {
            title: '资产类型',
            align: 'center',
            render: (h, params) => {
              return h('div', this.getItemNameById('asset_type', params.row.asset_type_id))
            },
            width: 70
          },
          {
            title: '设备类型',
            align: 'center',
            render: (h, params) => {
              return h('div', this.getItemNameById('asset_device_type', params.row.asset_device_type_id))
            },
            width: 70
          },
          {
            title: '品牌',
            align: 'center',
            render: (h, params) => {
              return h('div', this.getItemNameById('asset_brand', params.row.asset_brand_id))
            },
            width: 70
          },
          {
            title: '供应商',
            align: 'center',
            render: (h, params) => {
              return h('div', this.getItemNameById('payee_company', params.row.payee_company_id))
            },
            width: 70
          },
          {
            title: 'PN',
            align: 'center',
            key: 'pn',
            width: 120
          },
          {
            title: 'IMEI',
            align: 'center',
            key: 'imei',
            width: 120
          },
          {
            title: '附件清单',
            align: 'center',
            key: 'extra',
            width: 180,
            render: (h, params) => {
              const extra = params.row.extra;
              if (extra) {
                return h('div', {
                  'class': {
                    'asset-extra': true
                  },
                  domProps: {
                    innerHTML: extra
                  },
                })
              } else {
                return h('span', '-');
              }
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'desc',
            width: 180,
            render: (h, params) => {
              const desc = params.row.desc;
              if (desc) {
                return h('div', {
                  domProps: {
                    innerHTML: desc
                  },
                })
              } else {
                return h('span', '-');
              }
            }
          }
        ],
        config: {
          modal: false
        },
        asset_type_hash: {},
        asset_device_type_hash: {},
        asset_brand_hash: {},
        payee_company_hash: {},
        asset_name_hash: {}
      }
    },
    computed: {
      modal_title() {
        return `${this.customer.account} 的固定资产`;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      pageChange(new_page) {
        this.params.page = new_page;
        this.getAssets();
      },
      show(customer) {
        this.customer = customer;
        this.params.page = 1;
        this.params.customer_id = customer.id;
        this.config.modal = true;
        this.getAssets();
      },
      getAssets() {
        this.loading = true;
        this.assets = [];
        Util.ajax.get(Util.api.query_customer_assets, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            data.assets.forEach((asset) => {

              if (asset.asset_type) {
                this.asset_type_hash[asset.asset_type.id] = asset.asset_type;
              }
              if (asset.asset_device_type) {
                this.asset_device_type_hash[asset.asset_device_type.id] = asset.asset_device_type;
              }
              if (asset.asset_brand) {
                this.asset_brand_hash[asset.asset_brand.id] = asset.asset_brand;
              }
              if (asset.payee_company) {
                this.payee_company_hash[asset.payee_company.id] = asset.payee_company;
              }
              if (asset.asset_name) {
                this.asset_name_hash[asset.asset_name.id] = asset.asset_name;
              }
              this.assets.push(asset);
            });
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            //失败
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      getItemNameById(type, id) {
        const item = this[`${type}_hash`][id];
        return item ? item.name : '-';
      },
      exportAssets() {
        window.open(Util.api.export_customer_assets + '.xlsx?' + Util.urlEncode(this.params), '_blank');
      }
    }
  }
</script>
